/****
 * Health types shared across backend and frontend
 */
export var HealthCheckStatus;
(function (HealthCheckStatus) {
    HealthCheckStatus["healthy"] = "healthy";
    HealthCheckStatus["unhealthy"] = "unhealthy";
    HealthCheckStatus["notConfigured"] = "not_configured";
})(HealthCheckStatus || (HealthCheckStatus = {}));
//# sourceMappingURL=Health.js.map